import { coreComponentStyles } from '@main/pc-core-components';
import { responsive, sp } from '@main/theme';
import { colorIsLight } from '@main/theme-types';
import { createGlobalStyle } from 'styled-components';

/* eslint no-unused-expressions: 0 */
/**
 * Styles applied globally across the app.
 *
 * The amount of styling done here should be minimal
 */
export const PrivacyCenterGlobalStyles = createGlobalStyle`
  ::-moz-selection {
    color: ${({ theme }) =>
      colorIsLight(theme.colors.highlight)
        ? theme.colors.black
        : theme.colors.white}!important;
    background: ${({ theme }) => theme.colors.highlight}!important;
  }

  ::selection {
    color: ${({ theme }) =>
      colorIsLight(theme.colors.highlight)
        ? theme.colors.black
        : theme.colors.white}!important;
    background: ${({ theme }) => theme.colors.highlight}!important;
  }

  // Increase selectivity so that ant styles are overridden
  html > body {
    font-family: '${({ theme }) => theme.textStyles.fontFamilyBody.name}';
    height: 100%;
    background-color: ${({ theme }) => theme.colors.bgAccent};
    color: ${({ theme }) => theme.colors.textOnBg};

    font-size: ${sp(2 * 0.875)}; // 14 px
    ${responsive.atLeastDesktop} {
      font-size: ${sp(2)}; // 16 px
    }
    ${({ theme }) => theme.componentStyles.body};
  }

  a {
    font-family: '${({ theme }) => theme.textStyles.fontFamilyBody.name}';
    font-weight: 600;
    color: ${({ theme }) => theme.colors.secondary};
    transition: all 0.3s;
    overflow-wrap: anywhere;

    &:hover {
      color: ${({ theme }) => theme.colors.secondary};
      opacity: 0.8;
    }
    &:focus {
      opacity: 0.8;
    }
  }

  ${coreComponentStyles}

  #app {
    min-height: 100%;
  }

  .table-header > p {
    color: ${({ theme }) =>
      colorIsLight(theme.colors.tableOutline)
        ? theme.colors.black
        : theme.colors.white}!important;
  }
`;
